export const GET_LOGO_CINEMA = "GET_LOGO_CINEMA";
export const GET_DETAIL_CINEMA = "GET_DETAIL_CINEMA";
export const GET_LIST_MOVIE_DETAIL_CINEMA = "GET_LIST_MOVIE_DETAIL_CINEMA";
export const GET_INFO_MOVIE_DETAIL_CINEMA = "GET_INFO_MOVIE_DETAIL_CINEMA";
export const SHOW_SCHEDULE_MOVIE_CINEMADETAIL = "SHOW_SCHEDULE_MOVIE_CINEMADETAIL"